<template>
  <div class="edit-common-wraps">
    <div class="wrap-content">
      <div class="edit-common-box">
        <!-- AI主播 -->
        <div class="titles-box">
          AI主播
          <material-select :type="3" @selected="handleSelectedAnchor">
            <template slot="body">
              <a-button
                type="primary"
                ghost
                >上傳影片</a-button
              >
            </template>
          </material-select>
        </div>
        <div class="contents-box">
          <div class="audio-box max">
            <template v-if="aiObj.anchor_url">
              <div class="img-box" v-if="aiObj.anchor_url">
                <!-- 播放影片按鈕 -->
                <div class="video-play-btn" @click="playVideo">
                  <a-icon type="pause" v-if="videoPlay" />
                  <a-icon type="caret-right" v-else />
                </div>
                <!-- 刪除影片 -->
                <div class="video-del-btn" @click="delVideo">
                  <a-icon type="delete" />
                </div>
                <video
                  ref="video"
                  height="100%"
                  id="myVideo"
                  muted
                  :src="aiObj.anchor_url"
                  width="100%"
                ></video>
              </div>
            </template>
            <span class="tips" v-else>暫無主播</span>
          </div>
        </div>

        <!-- 語音解說 -->
        <div class="titles-box">
          語音解說
          <material-select :type="2" @selected="handleSelectedSpeech">
            <template slot="body">
              <a-button
                type="primary"
                ghost
                >選擇語音</a-button
              >
            </template>
          </material-select>
        </div>
        <div class="contents-box">
          <div class="audio-box">
            <template v-if="aiObj.speech_explain_url">
              <!-- 播放按鈕 -->
              <div class="play-btn" @click="playSpeech">
                <a-icon type="pause" v-if="speechPlay" />
                <a-icon type="caret-right" v-else />
              </div>
              <!-- 數據 -->
              <div class="right-info">
                <div class="names">{{ aiObj.speech_explain_name }}</div>
                <span class="del" @click="delSpeech">刪除</span>
              </div>
            </template>
            <span class="tips" v-else>暫無語音</span>
            <!-- 播放器 -->
            <audio
              id="speechAudio"
              controls="controls"
              alt="example"
              style="display: none"
              :src="aiObj.speech_explain_url ? aiObj.speech_explain_url : ''"
            ></audio>
          </div>
        </div>
      </div>
      <!-- AI去背 -->
      <div class="edit-common-box">
        <div class="titles-box">
          AI去背
          <div class="straw-box">
            <input type="color" id="strawInput" />
            <img src="@/assets/img/straw.png" class="imgs" />
          </div>
        </div>
        <div class="contents-box">
          <div class="color-box">
            顏色值：
            <div class="boxs">
              <div
                class="color-k"
                :style="{ backgroundColor: setColor(aiObj.color) }"
              ></div>
              <span>{{ setColor(aiObj.color) }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 位置設置 -->
      <div class="edit-common-box">
        <div class="titles-box">位置設置</div>
        <div class="contents-box">
          <div class="set-box">
            <div class="labels">位置：</div>
            <div class="con-box">
              <div
                class="lists"
                :class="{active: item == aiObj.position}"
                @click="aiObj.position = item"
                v-for="(item, index) in position"
                :key="index"
              >
                <img :src="require(`@/assets/img/position_${item}.png`)" />
              </div>
            </div>
          </div>
          <div class="set-box">
            <div class="labels">尺寸：</div>
            <div class="con-box">
              <div
                class="lists"
                :class="{active: item == aiObj.size}"
                @click="aiObj.size = item"
                v-for="(item, index) in size"
                :key="index"
              >
                <img :src="require(`@/assets/img/size_${item}.png`)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="edit-common-box">
        <!-- 是否自動播放和選擇場景 -->
        <div class="titles-box" v-if="aiObj.anchor_url">
          <span
            >預設開啟<span
              style="font-size: 13px; color: rgba(255, 255, 255, 0.8)"
              >(進入場景自動播放)</span
            ></span
          >
          <a-checkbox
            :checked="aiObj.is_auto ? true : false"
            @change="changeAuto"
          ></a-checkbox>
        </div>
        <div class="titles-box" v-if="aiObj.anchor_url">
          <span
            >循環播放<span
              style="font-size: 13px; color: rgba(255, 255, 255, 0.8)"
              >(AI主播)</span
            ></span
          >
          <a-switch
            :checked="aiObj.loopPlay === 1"
            @change="changeRepeat"
            :checked-children="$t('enum.switch.1')"
            :un-checked-children="$t('enum.switch.0')"
          />
        </div>
        <div class="titles-box">
          選擇應用場景<SelectScene
            :showTip="aiObj.anchor_url ? false : true"
            @selected="selectScene"
          ></SelectScene>
        </div>
      </div>
    </div>
    <div class="wrap-bottom">
      <a-button
        type="primary"
        @click="updateStore"
        >保存</a-button
      >
    </div>
  </div>
</template>

<script>
import MaterialSelect from "@/components/MaterialSelect";
import SelectScene from "../SelectScene";
import { mapGetters } from "vuex";
const defaultObj = {
  anchor_url: "", // 主播影片地址
  speech_explain_url: "", //語音地址
  speech_explain_name: "", //語音名稱
  is_auto: 1, //自動播放
  loopPlay: 1, //循環播放
  color: "RGB(0,0,0)", // 顔色
  position: "left", //位置
  size: "s", //尺寸
};
export default {
  name: "Index",
  components: {
    MaterialSelect,
    SelectScene,
  },
  data() {
    return {
      aiObj: {
        anchor_url: "", // 主播影片地址https://tainan720.s3.ap-southeast-1.amazonaws.com/1/web/video/o_1h9pafp8a7gt1cl913locer1bf7h.mp4
        speech_explain_url: "", //語音地址
        speech_explain_name: "", //語音名稱
        is_auto: 1, //自動播放
        loopPlay: 1, //循環播放
        color: "RGB(0,0,0)", // 顔色
        position: "left", //位置
        size: "s", //尺寸
      },
      position: ["left", "right"],
      size: ["s", "m", "l"],

      speechPlay: false,
      videoPlay: false,
    };
  },
  computed: {
    ...mapGetters(["vrbase", "currentScenesId", "userInfo"]),
    newAiObj() {
      return this.$deepClone(this.aiObj);
    },
  },
  watch: {
    newAiObj: {
      handler(newv, oldv) {
        const index = this.vrbase.scenes[this.currentScenesId];
        let vrbase = this.$deepClone(this.vrbase);
        if (index) {
          this.$set(vrbase.scenes[this.currentScenesId], "ai_anchor", newv);
          this.$store.dispatch("setVRBase", vrbase);
        }
        this.$emit("change", newv, oldv);
      },
      deep: true,
    },
    currentScenesId: {
      handler(newv, oldv) {
        if (newv) this.handlerData();
      },
      immediate: true,
    },
    "aiObj.loopPlay": function (newVal) {
      // console.log(`loopPlay的值變更為: ${newVal}`);
      const videoDom = this.$refs.video;
      if (videoDom) {
        videoDom.loop = newVal === 1;
      }
    },
  },
  mounted() {
    //監聽input color 的顔色改變
    let _this = this;
    const theInput = document.getElementById("strawInput");
    theInput.addEventListener(
      "input",
      function () {
        _this.aiObj.color = _this.conversion(theInput.value);
      },
      false
    );

    //監聽ai主播被點擊播放還是暫停
    window.updateVideoStatus = this.updateVideo;

    const myVideo = this.$refs.video;

    // 監聽影片播放事件，當影片播放時，更新 videoPlay 狀態
    myVideo.addEventListener("play", () => {
      this.videoPlay = true;
      this.$emit("videoChange", this.videoPlay);
    });

    // 監聽影片暫停事件
    myVideo.addEventListener("pause", () => {
      this.videoPlay = false;
      this.$emit("videoChange", this.videoPlay);

      this.$root.$emit("pause-digital-human");
    });

    // 監聽影片播放結束事件
    myVideo.addEventListener("ended", this.onVideoEnded);
  },
  beforeDestroy() {
    const myVideo = document.getElementById("myVideo");
    myVideo.removeEventListener("ended", this.onVideoEnded);
  },
  methods: {
    //獲取數據
    handlerData() {
      const data = this.vrbase.scenes[this.currentScenesId];
      if (data && Object.keys(data.ai_anchor).length) {
        // && data.ai_anchor.anchor_url
        if (data.ai_anchor.anchor_url != this.aiObj.anchor_url)
          this.videoPlay = false;
        if (data.ai_anchor.speech_explain_url != this.aiObj.speech_explain_url)
          this.speechPlay = false;
        this.aiObj = this.$deepClone(data.ai_anchor);
      } else {
        this.aiObj = this.$deepClone(defaultObj);
        this.speechPlay = false;
        this.videoPlay = false;
      }
    },
    //選擇背景音樂
    handleSelectedAnchor(value) {
      if (this.aiObj.anchor_url && this.videoPlay) {
        this.$emit("videoChange", this.videoPlay); //傳遞從編輯裏面播放還是暫停
        const myVideo = document.getElementById("myVideo");
        myVideo.pause();
        this.videoPlay = false;
      }
      this.aiObj.anchor_url = value.url;
    },
    //播放視頻
    playVideo() {
      const myVideo = this.$refs.video;
      const speechAudio = document.getElementById("speechAudio");

      if (this.videoPlay) {
        // 暫停小影片
        myVideo.pause();
        this.videoPlay = false;

        // 暫停大影片
        this.$root.$emit("pause-digital-human");
      } else {
        // 播放小影片
        myVideo
          .play()
          .then(() => {
            this.videoPlay = true;

            // 確保語音暫停
            if (speechAudio && !speechAudio.paused) {
              speechAudio.pause();
              this.speechPlay = false;
            }

            // 播放大影片
            this.$root.$emit("play-digital-human");
          })
          .catch((error) => {
            console.warn("播放小影片時遇到錯誤：", error);
          });
      }
    },
    //刪除背景音樂
    delVideo() {
      this.aiObj.anchor_url = "";
      this.videoPlay = false;
    },
    //選擇語音解說
    handleSelectedSpeech(value) {
      this.aiObj.speech_explain_url = value.url;
      this.aiObj.speech_explain_name = value.name;
    },
    //刪除語音解說
    delSpeech() {
      this.aiObj.speech_explain_url = "";
      this.aiObj.speech_explain_name = "";
      this.speechPlay = false;
    },
    //播放
    playSpeech() {
      const myVideo = document.getElementById("myVideo");
      const speechAudio = document.getElementById("speechAudio");
      if (this.speechPlay) {
        speechAudio.pause();
        this.speechPlay = false;
      } else {
        speechAudio.play();
        this.speechPlay = true;
        if (this.videoPlay) {
          this.$emit("videoChange", this.videoPlay);
          myVideo.pause();
          this.videoPlay = false;
        }
      }
    },
    //獲取語音解說的場景
    selectScene(ids) {
      const newIds = ids.filter((obj) => obj != this.currentScenesId);
      const vrbase = this.$deepClone(this.vrbase);
      const sceneKeys = Object.keys(vrbase.scenes);
      sceneKeys.forEach((obj) => {
        if (newIds.includes(obj)) {
          if (this.aiObj.anchor_url || this.aiObj.speech_explain_url) {
            vrbase.scenes[obj].ai_anchor = this.$deepClone(this.aiObj);
          } else {
            vrbase.scenes[obj].ai_anchor = this.$deepClone(defaultObj);
          }
        }
      });
      this.$store.dispatch("setVRBase", vrbase);
      this.$message.success("已成功應用到選擇的場景");
    },
    //切換是否自動播放
    changeAuto(e) {
      this.aiObj.is_auto = e.target.checked ? 1 : 0;
    },
    //切換是否循環播放
    changeRepeat(checked) {
      this.aiObj.loopPlay = checked ? 1 : 0;
      const videoDom = this.$refs.video;
      if (videoDom) {
        videoDom.loop = this.aiObj.loopPlay === 1;
      }

      this.$root.$emit("update-loopPlay", this.aiObj.loopPlay);
    },
    onVideoEnded() {
      const myVideo = this.$refs.video;

      console.log(`loopPlay 的當前值: ${this.aiObj.loopPlay}`);

      if (this.aiObj.loopPlay === 0) {
        myVideo.pause();
        myVideo.currentTime = 0;
        this.videoPlay = false;
        this.$emit("videoChange", this.videoPlay);

        this.$root.$emit("pause-digital-human");
      }
    },
    //16進制轉爲rgb
    conversion(value) {
      // 16進制顔色值的正則
      let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      // 把顔色值變成小寫
      let color = value.toLowerCase();
      if (reg.test(color)) {
        // 如果只有三位的值，需變成六位，如：#fff => #ffffff
        if (color.length === 4) {
          let colorNew = "#";
          for (let i = 1; i < 4; i += 1) {
            colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
          }
          color = colorNew;
        }
        // 處理六位的颜色值，轉爲RGB
        let colorChange = [];
        for (let j = 1; j < 7; j += 2) {
          colorChange.push(parseInt("0x" + color.slice(j, j + 2)));
        }
        return "RGB(" + colorChange.join(",") + ")";
      } else {
        return color;
      }
    },
    //rgb轉爲16進制
    setColor(rgb) {
      if (!rgb) rgb = "rgb(0,0,0)";
      var regexp = /[0-9]{0,3}/g;
      var res = rgb.match(regexp); // 利用正则表达式去掉多余的部分，将rgb中的数字提取
      var hexRes = "#";
      var hex = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
      ];
      var hexArr = [];
      for (let i = 0; i < res.length; i++) {
        if (res[i]) {
          if (res[i] > 16) {
            let leftIndex = (res[i] / 16) >> 0; // 向下取整
            let rightIndex = +res[i] % 16;
            hexArr.push(hex[leftIndex]);
            hexArr.push(hex[rightIndex]);
          } else {
            hexArr.push(0);
            hexArr.push(hex[res[i]]);
          }
        }
      }
      return (hexRes += hexArr.join("")); // #EDEDED
    },
    updateStore() {
      // 保存按鈕
      const vrbase = { ...this.vrbase };
      this.$store.dispatch(
        "saveVRBase",
        {
          vrbase,
          showLoading: true,
        },
        true
      );
    },
  },
};
</script>

<style lang="less" scoped>
#myVideo {
  display: block;
}
.edit-common-wraps {
  height: calc(100vh - 52px);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .wrap-content {
    flex: 1;
    overflow: hidden;
    overflow-y: auto;
    padding: 0 20px;

    .edit-common-box {
      padding: 10px 0;
      border-bottom: 1px solid #111111;
      &.only {
        padding: 0;
      }

      &:last-child {
        border-bottom: 0;
      }
      .titles-box {
        font-size: 16px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
        & span {
          display: flex;
          align-items: center;
        }
        &.mar-20 {
          margin-top: 30px;
        }
        .ant-checkbox-wrapper {
          color: #ffffff;
        }
        .speechBtn {
          color: #d485ff;
          border-color: #d485ff;
        }
        .uploadVideoBtn {
          color: #d485ff;
          border-color: #d485ff;
        }
        .selectBtn {
          color: #d485ff;
          border-color: #d485ff;
        }
      }
    }
  }

  .wrap-bottom {
    flex-shrink: 0;
    padding: 20px;
    .saveBtn {
      background-color: #7101ad;
      border-color: #7101ad;
    }
  }
}

.audio-box {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2b2b2b;
  border: 1px solid #555;
  border-radius: 4px;
  padding: 0 12px;
  height: 70px;
  .img-box {
    position: relative;
    width: 100%;
    height: 100%;
    .video-play-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 10;
      transform: translate(-50%, -50%);
      width: 34px;
      height: 34px;
      border-radius: 50%;
      flex-shrink: 0;
      cursor: pointer;
      user-select: none;
      transition: background-color 0.3s ease;
      &:hover {
        background-color: rgba(0, 0, 0, 0.8);
      }
      .anticon {
        font-size: 22px;
        color: #ffffff;
      }
    }

    .video-del-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 6px;
      right: 6px;
      width: 26px;
      height: 26px;
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.5);
      cursor: pointer;
      transition: background-color 0.3s ease;
      z-index: 4;
      &:hover {
        background-color: rgba(0, 0, 0, 0.7);
      }
      .anticon {
        font-size: 12px;
        color: #ffffff;
      }
    }
  }
  &.max {
    height: 140px;
    padding: 0;
  }
  .tips {
    font-size: 16px;
    color: #aaa;
  }
  .play-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 10px;
    width: 38px;
    height: 38px;
    border: 2px solid #ffffff;
    border-radius: 50%;
    cursor: pointer;
    user-select: none;
    .anticon {
      font-size: 24px;
      color: #ffffff;
    }
  }

  .right-info {
    flex: 1;
    overflow: hidden;
    .names {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 15px;
      color: #ffffff;
    }
    .del {
      margin-top: 0;
      display: inline-block;
      color: #9f2e2d;
      font-size: 14px;
      cursor: pointer;
      user-select: none;
    }
  }
}

.straw-box {
  width: 24px;
  height: 24px;
  border-radius: 3px;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  #strawInput {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    cursor: pointer;
  }

  .imgs {
    width: 12px;
    opacity: 0.8;
  }
}

.color-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  font-size: 14px;
  padding: 10px 0;
  .boxs {
    flex: 1;
    margin-left: 30px;
    background-color: rgba(255, 255, 255, 0.2);
    height: 28px;
    display: flex;
    align-items: center;
    color: #ffffff;
    padding: 0 5px;

    .color-k {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      margin-right: 10px;
      background-color: #000000;
    }
  }
}

.set-box {
  .labels {
    font-size: 14px;
    color: #ffffff;
    padding: 6px 0;
  }
  .con-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 36px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    padding: 2px;

    .lists {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      cursor: pointer;

      img {
        width: 18px;
      }

      &.active {
        background-color: #015c61;
        // background-color: #7101ad;
        border-radius: 3px;
      }
      &.active.locationSelect {
        background-color: #7101ad;
      }
    }
  }
}
</style>
